// material-ui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

// third party
import { Link as RouterLink } from 'react-router-dom';

export default function Footer() {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={{ xs: 1, sm: 2 }}
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        pt: 3,
        mt: 'auto',
        flexWrap: 'wrap',
        gap: 1
      }}
    >
      <Typography variant="caption" color="text.secondary">
        &copy; {new Date().getFullYear()} Synlets. All rights reserved.
      </Typography>
      <Stack direction="row" spacing={2}>
        <Link
          component={RouterLink}
          to="/privacy-policy"
          variant="caption"
          color="text.secondary"
          underline="hover"
          sx={{ '&:hover': { color: 'text.primary' } }}
        >
          Privacy Policy
        </Link>
        <Link
          component={RouterLink}
          to="/terms-of-service"
          variant="caption"
          color="text.secondary"
          underline="hover"
          sx={{ '&:hover': { color: 'text.primary' } }}
        >
          Terms of Service
        </Link>
      </Stack>
    </Stack>
  );
}
